import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { TextLoca } from "../generic/text/TextLoca";
export var RankingPlacementLeagueHeading = function (_a) {
    var ranking = _a.ranking;
    var locaReplacements;
    var locaString;
    if (ranking.min === ranking.max) {
        locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(ranking.min)]]);
        locaString = IdLoca.rankings_singleRankX;
    }
    else {
        locaReplacements = new Map([
            [ReplacementLoca.zero_0, utilNumber.format(ranking.max)],
            [ReplacementLoca.one_1, utilNumber.format(ranking.min)],
        ]);
        locaString = IdLoca.rankings_rangeRanksXToY;
    }
    return (React.createElement(TextLoca, { className: "" + IdStyles.TextBoldPrimary, replacements: locaReplacements, id: locaString }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/RankingPlacementLeagueHeading.tsx
// module id = 2801
// module chunks = 3